import { ProcStage, ProcCondition, OrderEffStatus } from "../../../api/maintenance";

/** Lifecycle order — generated -> dispatched -> received -> onboarded (+ retired). */
export const STAGES: { key: ProcStage; label: string; cls: string; dot: string; desc: string }[] = [
  { key: "generated",  label: "Generated",  cls: "blue",   dot: "c-blue",   desc: "ID + QR minted. Not yet ordered." },
  { key: "dispatched", label: "Dispatched", cls: "orange", dot: "c-orange", desc: "On an issued order, out with the manufacturer." },
  { key: "received",   label: "Received",   cls: "purple", dot: "c-purple", desc: "Arrived and OK — ready to onboard." },
  { key: "onboarded",  label: "Onboarded",  cls: "green",  dot: "c-green",  desc: "Live in the Devices console." },
  { key: "retired",    label: "Retired",    cls: "red",    dot: "c-red",    desc: "Faulty / DOA / written off. Never deleted." },
];

export const stageMeta = (s: ProcStage | string) =>
  STAGES.find((x) => x.key === s) || { key: s as ProcStage, label: String(s), cls: "grey", dot: "", desc: "" };

export const ORDER_STATUS: Record<OrderEffStatus, { label: string; cls: string }> = {
  draft:     { label: "Draft",              cls: "grey" },
  issued:    { label: "Issued",             cls: "orange" },
  partial:   { label: "Partially received", cls: "purple" },
  closed:    { label: "Closed",             cls: "green" },
  cancelled: { label: "Cancelled",          cls: "red" },
};

export const CONDITIONS: { key: ProcCondition; label: string }[] = [
  { key: "ok",         label: "Received — OK" },
  { key: "damaged",    label: "Damaged in transit" },
  { key: "doa",        label: "Dead on arrival" },
  { key: "wrong_item", label: "Wrong item" },
];

export const conditionMeta = (c: ProcCondition | null) => {
  if (!c) return { label: "outstanding", cls: "orange" };
  if (c === "ok") return { label: "received", cls: "green" };
  return { label: c === "doa" ? "DOA" : c === "damaged" ? "damaged" : "wrong item", cls: "red" };
};

export const fmtDate = (d: string | null | undefined) => {
  if (!d) return "—";
  try {
    return new Date(d).toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
  } catch {
    return d;
  }
};

export const fmtDateTime = (d: string | null | undefined) => {
  if (!d) return "—";
  try {
    return new Date(d).toLocaleString();
  } catch {
    return d;
  }
};

/** Pull the API's `detail` message out of an axios error, with a sane fallback. */
export const errMsg = (e: any, fallback: string) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d) && d[0]?.msg) return d[0].msg;
  return fallback;
};
